import CtaButton from './CtaButton';
import './CtaBanner.css';

export default function CtaBanner() {
  return (
    <section className="cta-banner">
      <div className="container cta-banner-inner">
        <div>
          <h2>Not Sure How to Update Your GPS?</h2>
          <p>Make sure your device is fully charged and connected to a stable internet connection before starting.</p>
        </div>
        <CtaButton className="btn btn-primary cta-banner-btn btn--inline">
          Map Update
        </CtaButton>
      </div>
    </section>
  );
}
